import React from 'react';

export default ({ input, label }) => (
  <div className="checkbox">
    <label>
      <input type="checkbox" {...input} />
      {label}
    </label>
  </div>
);
